interface CardTitleProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {}

export default function CardTitle({
  children,
  className = '',
  ...rest
}: CardTitleProps) {
  return (
    <h2 className={`card-title ${className}`} {...rest}>
      {children}
    </h2>
  );
}
